"use client";

import { useState, type ReactNode } from "react";
import { COMPANION_SPORTS, type CompanionSport } from "./companion-sports";

/**
 * Client island for the homepage Companion section: the sport chips, and
 * which server-rendered tile grid (from CompanionTileGrid) is showing. The
 * grids arrive as `panels`, so the SVG visuals never ship as client JS.
 */

export function HomeCompanionTiles({ panels }: { panels: Record<CompanionSport, ReactNode> }) {
  const [sport, setSport] = useState<CompanionSport>("ski");
  const name = COMPANION_SPORTS.find((entry) => entry.key === sport)?.name ?? sport;
  return (
    <div>
      <div role="group" aria-label="Choose a sport for Companion features" className="flex flex-wrap items-center gap-2">
        {COMPANION_SPORTS.map((entry) => {
          const active = entry.key === sport;
          return (
            <button
              key={entry.key}
              type="button"
              aria-pressed={active}
              onClick={() => setSport(entry.key)}
              data-ph-capture-attribute-home-cta={`companion-chip-${entry.key}`}
              className={`min-h-11 shrink-0 whitespace-nowrap rounded-full border px-4 text-[14px] font-semibold transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-dark ${
                active ? "border-navy bg-navy text-white" : "border-navy/20 bg-white text-navy hover:bg-[#EEF2EC]"
              }`}
            >
              {entry.label}
            </button>
          );
        })}
      </div>
      <p className="sr-only" aria-live="polite">
        {`Showing Companion features for ${name}`}
      </p>
      <figure className="m-0 mt-3">
        {/* key remounts the grid so its tiles replay the entry animation. */}
        <div key={sport}>{panels[sport]}</div>
        <figcaption className="mt-2 text-[12px] leading-[1.3] text-[#566072]">Example screens</figcaption>
      </figure>
    </div>
  );
}
